












import Vue, { PropOptions } from 'vue';
import { Integration, BotStatus } from '@/models';
import ButtonAction from '@/components/ButtonAction.vue';

export default Vue.extend({
  components: { ButtonAction },
  props: {
    bot: Object as PropOptions<Integration>,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async activate() {
      this.loading = true;
      try {
        const bots = this.$store.state.bot.bots;
        for (const bot of bots) {
          if (bot.status === BotStatus.Ready && bot.objectId !== this.bot.objectId) {
            bot.status = BotStatus.Inactive;
            await this.$store.dispatch('saveBot', bot);
          }
        }

        this.bot.status = BotStatus.Ready;
        await this.$store.dispatch('updateBot', this.bot);

        await this.$store.dispatch('convertToV2', this.bot);
        this.$store.commit('addSnackbar', {
          text: `Bot ativado com sucesso!`,
          color: 'success',
        });
      } catch (error) {
        this.bot.status = BotStatus.Inactive;
        await this.$store.dispatch('updateBot', this.bot);
        this.$store.commit('addSnackbar', {
          text: `Erro ao ativar bot: ${error.message}`,
        });
      }
      this.loading = false;
    },
  },
});
